import React from "react";
import TSTable from "../../common/TSTable";
import { FilePdfOutlined } from '@ant-design/icons';
import { URL_POND } from "../../constants/urls";
import { POND_STATUS, POND_STATUS_TH, } from "../../constants/string";
import _ from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import { dateToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import PondWeightLogModal from "./PondWeightLogModal";
import PondStatusLogModal from "./PondStatusLogModal";
import { Button, Tooltip } from "antd";
import { PATH } from "../../routes/CustomRoutes";

const PondLotHistoryList = React.forwardRef((props, ref) => {

  const [errorMessage, setErrorMessage] = React.useState(null);
  const [targetWeightLog, setTargetWeightLog] = React.useState(null);
  const [targetStatusLog, setTargetStatusLog] = React.useState(null);
  const tableRef = React.useRef();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useImperativeHandle(ref, () => ({
    fetch : () => refreshData()
  }));

  const columns = [
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render : (value) => <center>{value ? dateToHumanString(value) : '-'}</center>
    },
    {
      title: 'บ่อพัก',
      dataIndex: 'pond_name',
      key: 'pond_name',
      searcher: true,
      render : (value) => value ? value : '-'
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      searcher: true,
      render : (value, original) => value ? 
        <>
          {value}
          <Tooltip triger='hover' title='รายละเอียดสต๊อกน้ำยางสด'>
            <Button type='link' icon={<FilePdfOutlined />} onClick={() => window.open(`${window.origin}${PATH.POND_SUMMARY}/${original.id}`)}/>
          </Tooltip>
        </> : '-'
    },
    {
      title: 'น้ำหนัก (Kgs)',
      dataIndex: 'current_weight',
      key: 'current_weight',
      render : (value, original) => <center>{value ? <Tooltip triger='hover' title={"ประวัติเปลี่ยนน้ำหนัก"}><a onClick={() => setTargetWeightLog(original.id)}>{formatComma(toFixed(value, 0))}</a></Tooltip> : '-'}</center>
    },
    {
      title: 'น้ำหนักวัดเทียบ (Kgs)',
      dataIndex: 'close_weight',
      key: 'close_weight',
      render : (value) => <center>{formatComma(toFixed(value, 0))}</center>
    },
    {
      title: 'น้ำหนักสะพานชั่ง (Kgs)',
      dataIndex: 'truck_transactions_weight',
      key: 'truck_transactions_weight',
      render : (value) => <center>{formatComma(toFixed(value, 0))}</center>
    },
    {
      title: 'สถานะ',
      dataIndex: 'state',
      key: 'state',
      render : (value, original) => value ? <Tooltip triger='hover' title={"ประวัติเปลี่ยนสถานะ"}><a onClick={() => setTargetStatusLog(original.id)}>{POND_STATUS_TH[value]}</a></Tooltip> : '-'
    },
  ]

  return(
    <div>
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_POND.POND_TRANSACTION}
        params={{state : POND_STATUS.END}}
      />

      <PondWeightLogModal
        open={targetWeightLog ? true : false}
        target={targetWeightLog}
        onClose={() => 
          setTargetWeightLog(null)
        }
      />

      <PondStatusLogModal
        open={targetStatusLog ? true : false}
        target={targetStatusLog}
        onClose={() => 
          setTargetStatusLog(null)
        }
        onUpdate={() => {
          setTargetStatusLog(null)
          refreshData();
        }}
      />
    </div>
  )
})

export default PondLotHistoryList;